import React from "react";
import { UserComment } from "../../redux/types";
import moment from "moment-jalaali";
import RatingStars from "../shared/rating-stars/rating-stars";

const CommentDetail = ({
  comment,
  showDayOfWeek = false,
}: {
  comment: UserComment;
  showDayOfWeek?: boolean;
  replying?: boolean;
}) => {
  const date = moment.unix(parseInt(comment.created)).format("jYYYY/jM/jD");
  const dayofweek = moment.unix(parseInt(comment.created)).format("dddd");

  return (
    <>
      <div className="pt-4 text-sm font-medium text-pkc-greyish-brown">
        {comment.fullName !== "anonymous" ? (
          comment.fullName
        ) : (
          <>
            <span>کاربر ناشناس</span>
            <span className="mr-1 text-xs font-normal text-pkc-disable">(عدم تمایل کاربر به نمایش مشخصات)</span>
          </>
        )}
      </div>
      <div className="pt-4">حالت نمایش : {comment.status}</div>
      <div
        className={`flex items-center justify-between pt-4 mb-2 ${showDayOfWeek ? "text-sm font-medium" : "text-xs"}`}
      >
        <div>
          {showDayOfWeek ? dayofweek : <i className="text-blue-900 far fa-calendar-check" />}

          <span className={`mr-3 font-normal ${showDayOfWeek ? "font-medium" : "text-pkc-description-text"} `}>
            {date}
          </span>
        </div>
        <div>
          <RatingStars className="p-0 border-0 text-pkc-gold" value={comment.rating} />
        </div>
      </div>
      <div className={`py-2 px-3 text-xs font-medium text-pkc-greyish-brown leading-7 max-h-40 overflow-y-scroll `}>
        {comment.text}
      </div>
    </>
  );
};

export default CommentDetail;
